import Container from '../../../../constants/Container';
import { formatMoney_2 } from '../../../../helpers/DateFormat';
interface LedgerListProps {
    onLedgerList: any;
}
const LedgerListView: React.FC<LedgerListProps> = ({ onLedgerList }) => {
    return (
        <Container padding>
            <div className="relative overflow-x-auto">
                <table className="text-sm text-left rtl:text-right text-gray-100 whitespace-nowrap scroll-x-auto dark:text-gray-400 rounded w-full">
                    <thead className="text-[12px] text-gray-700 dark:border-b-sky-700 bg-slate-100 capitalize border-b dark:bg-sky-950 dark:text-slate-400 font-public-sans">
                        <tr className='bg-gray100'>
                            <th scope="col" align='center' className="px-2 py-1 w-10">
                                {"S.N."}
                            </th>
                            <th scope="col" className="px-2 py-1">
                                {"Date"}
                            </th>
                            <th scope="col" align='center' className="px-2 py-1">
                                {"TSN"}
                            </th>
                            <th scope="col" className="px-2 py-1">
                                {"Particular Name"}
                            </th>
                            <th scope="col" align='center' className="px-2 py-1">
                                {"Bill No."}
                            </th>
                            <th scope="col" className="px-2 py-1 w-20">
                                {"Cr"}
                            </th>
                            <th scope="col" className="px-2 py-1 w-20">
                                {"Dr"}
                            </th>
                            <th scope="col" align='center' className="px-2 py-1 w-20">
                                {"SubAcBal"}
                            </th>
                            <th scope="col" align='center' className="px-2 py-1 w-20">
                                {"Dr/Cr"}
                            </th>

                        </tr>
                    </thead>
                    <tbody className='text-slate-800'>
                        {
                            Array.isArray(onLedgerList?.results) && onLedgerList?.results?.map((ledger: any, index: number) => (
                                <tr key={index} className="odd:bg-white hover:bg-slate-100 text-[12px] text-gray-800 dark:text-gray-400 odd:dark:bg-sky-900 even:bg-slate-50 even:dark:bg-sky-800 border-b font-public-sans dark:border-b-sky-700">
                                    <td align='center' className="px-2 py-1 capitalize">
                                        {index + 1}.
                                    </td>
                                    <td align='left' className="px-2 py-1 font-medium capitalize">
                                        {ledger?.dated}
                                    </td>
                                    <td align='center' className="px-2 py-1 capitalize">
                                        {ledger?.tasn}
                                    </td>
                                    <td align='left' className="px-2 py-1 capitalize">
                                        {ledger?.particulars}
                                    </td>
                                    <td align='center' className="px-2 py-1 capitalize">
                                        {ledger?.billrno}
                                    </td>
                                    <td align='left' className="px-2 py-1 capitalize">
                                        {ledger?.dramt ? formatMoney_2(ledger?.dramt) : formatMoney_2(0)}
                                    </td>
                                    <td align='left' className="px-2 py-1 capitalize">
                                        {ledger?.cramt ? formatMoney_2(ledger?.cramt) : formatMoney_2(0)}
                                    </td>
                                    <td align='center' className="px-2 py-1 capitalize">
                                        {ledger?.subaccbal ? formatMoney_2(ledger?.subaccbal) : formatMoney_2(0)}
                                    </td>
                                    <td align='center' className="px-2 py-1 capitalize">
                                        {ledger?.subdrcr}
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
        </Container>
    )
}

export default LedgerListView